import React from 'react';
import { DateTime } from 'luxon';
import { Dropdown } from 'react-bootstrap'; // For 3-dot action
import { AssignmentInd, Delete, Edit, MoreVert } from '@mui/icons-material';

const ShiftCard = ({ shift, onEdit, onDelete, onAssign }) => {
  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-body position-relative">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h5 className="card-title mb-1">{shift.ShiftName}</h5>
            <p className="mb-2 text-muted">
              <i className="bi bi-geo-alt-fill me-2"></i>{shift.Location}
            </p>
          </div>

          {/* 3-dot action menu */}
          <Dropdown>
            <Dropdown.Toggle variant="link" className="p-0 shadow-none" bsPrefix="btn">
              <MoreVert/>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => onEdit(shift.WorkShiftId)}><Edit color='primary'/>{" "}Edit</Dropdown.Item>
              <Dropdown.Item onClick={() => onDelete(shift.WorkShiftId)}><Delete color='error'/> {" "} Delete</Dropdown.Item>
              <Dropdown.Item onClick={() => onAssign(shift.WorkShiftId)}><AssignmentInd color='warning'/> Assign {" "}</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="mt-3">
          <p className="mb-1">
            <strong>Timings:</strong>{' '}
            {DateTime.fromFormat(shift.FromTime, 'HH:mm:ss').toFormat('HH:mm')} -{' '}
            {DateTime.fromFormat(shift.ToTime, 'HH:mm:ss').toFormat('HH:mm')}
          </p>
          <p className="mb-1">
            <strong>Applicable:</strong>{' '}
            {DateTime.fromISO(shift.ShiftApplicableStartDate).toFormat('dd/MM/yyyy')} -{' '}
            {DateTime.fromISO(shift.ShiftApplicableEndDate).toFormat('dd/MM/yyyy')}
          </p>
          <p className="mb-1">
            <strong>Overtime:</strong>{' '}
            <span className={`badge bg-${shift.AllowOverTime ? 'success' : 'secondary'}`}>
              {shift.AllowOverTime ? 'Allowed' : 'Not Allowed'}
            </span>
          </p>
          <p className="mb-0">
            <strong>Auto Checkout:</strong>{' '}
            <span className={`badge bg-${shift.AutoCheckout ? 'primary' : 'secondary'}`}>
              {shift.AutoCheckout ? 'Enabled' : 'Disabled'}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShiftCard;
